import React, { useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import {
  MapContainer,
  Marker,
  TileLayer,
  useMap,
  ZoomControl,
} from 'react-leaflet';
import AddMarkers from './AddMarkers';
import './style.css';
import Direction from './Direction';
import Search from './Search';
import L from 'leaflet';
import { urlConfig } from '../../config/urlConfig';
import { CreateMeetingContext } from '../../services/create-meeting/create-meeting.context';
//style
const useStyle = makeStyles((theme) => {
  return {
    mapContainer: {
      height: 320,
    },
    memberIcon: {
      borderRadius: '50%',
    },
  };
});

const MapFitBound = ({ members, location }) => {
  const map = useMap();

  useEffect(() => {
    let locationList = [];

    members &&
      members.map((item) =>
        item.lat && item.lng ? locationList.push([item.lat, item.lng]) : null
      );

    location &&
      location.lat &&
      location.lng &&
      locationList.push([location.lat, location.lng]);

    locationList.length > 0 &&
      map.fitBounds(locationList, { padding: [60, 75] });
  }, [location, map, members]);
  return null;
};
//=====================================================================
const Map = () => {
  const classes = useStyle();

  const { states } = useContext(CreateMeetingContext);
  const { location, usersInfo } = states;

  const position = [29.62316571303948, 52.523923516273506];

  return (
    <MapContainer
      className={classes.mapContainer}
      center={location && location.lat && location.lng ? location : position}
      boundsOptions={{ padding: [60, 70] }}
      minZoom={1}
      zoom={usersInfo && location && location.lat && location.lng ? null : 15}
      zoomControl={false}
    >
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright"></a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      <ZoomControl position='topright' />

      {location && (
        <Direction location={location} position='bottomleft'></Direction>
      )}

      <AddMarkers />

      {usersInfo &&
        usersInfo.map((item) =>
          item.lat && item.lng ? (
            <Marker
              key={item.uuid}
              position={[item.lat, item.lng]}
              icon={
                new L.Icon({
                  iconUrl: item.avatar
                    ? item.avatar
                    : '/icons/default_profile.png',
                  popupAnchor: null,
                  className: classes.memberIcon,
                  iconSize: [50, 50],
                  iconAnchor: [12, 36],
                  shadowAnchor: [4, 62],
                })
              }
            />
          ) : null
        )}

      <Search />

      {usersInfo && <MapFitBound members={usersInfo} location={location} />}
    </MapContainer>
  );
};

export default Map;
